import { CatchIssueUseCase } from '../useCases/catch-issue.usecase';

export const makeCatchIssueUseCase = () => {
  return new CatchIssueUseCase();
};
